import { typeName } from "./helpers";

/**
 * Represents a caught value that was not an error
 */
export class NonErrorThrownError extends Error {
  public readonly org: unknown;
  constructor(org: unknown) {
    super(`Non-error value thrown: ${typeName(org)}`);
    this.org = org;
  }
}
